import { AppointmentType } from '@pt/pt-models';

export class AppQueryParams {
  public static ENTITY_ID = 'id';
  public static DETAILS_OPENED = 'opened';
  public static APPOINTMENTS_TAB = 'at';

  public static appointmentsTabAvailableValues = {
    [AppointmentType.APPOINTMENT_RESPONSIBLE]: 'resp',
    [AppointmentType.APPOINTMENT_AUTHORIZED]: 'auth',
    [AppointmentType.APPOINTMENT_SYSTEM_ADMIN]: 'sys'
  };

  public static detailsOpenedAvailableValues = {
    'true': 'true',
    'false': 'false'
  };

  public static getAvailableValues(key: 'ENTITY_ID' | 'DETAILS_OPENED' | 'APPOINTMENTS_TAB') {
    switch (key) {
      case 'APPOINTMENTS_TAB':
        return this.appointmentsTabAvailableValues;
      case 'DETAILS_OPENED':
        return this.detailsOpenedAvailableValues;
      case 'ENTITY_ID':
        break;
    }
  }

  public static isValid(key: 'ENTITY_ID' | 'DETAILS_OPENED' | 'APPOINTMENTS_TAB', value: string) {
    switch (key) {
      case 'APPOINTMENTS_TAB':
        return value === this.appointmentsTabAvailableValues[AppointmentType.APPOINTMENT_RESPONSIBLE]
          || value === this.appointmentsTabAvailableValues[AppointmentType.APPOINTMENT_AUTHORIZED]
          || value === this.appointmentsTabAvailableValues[AppointmentType.APPOINTMENT_SYSTEM_ADMIN];
      case 'DETAILS_OPENED':
        break;
      case 'ENTITY_ID':
        break;
    }
  }

  public static reverseValue(key: 'ENTITY_ID' | 'DETAILS_OPENED' | 'APPOINTMENTS_TAB', value: string): AppointmentType | undefined {
    switch (key) {
      case 'APPOINTMENTS_TAB': {
        const t = this.appointmentsTabAvailableValues;
        if (value === t[AppointmentType.APPOINTMENT_AUTHORIZED]) {
          return AppointmentType.APPOINTMENT_AUTHORIZED; // AppointmentType.APPOINTMENT_AUTHORIZED;
        }
        if (value === t[AppointmentType.APPOINTMENT_RESPONSIBLE]) {
          return AppointmentType.APPOINTMENT_RESPONSIBLE;
        }
        if (value === t[AppointmentType.APPOINTMENT_SYSTEM_ADMIN]) {
          return AppointmentType.APPOINTMENT_SYSTEM_ADMIN;
        }
      }
        break;
      case 'DETAILS_OPENED':
        break;
      case 'ENTITY_ID':
        break;
    }
  }
}


